import { useState } from "react"

export const useConfirmAbandonDialog = () => {
    const [confirmAbandonDialogState, setIsOpen] = useState(false)

    const handleOpenConfirmAbandonDialog = () => setIsOpen(true)
    const handleCloseConfirmAbandonDialog = () => setIsOpen(false)

    return { confirmAbandonDialogState, handleOpenConfirmAbandonDialog, handleCloseConfirmAbandonDialog }
}
